import { FC, ReactNode } from "react";

interface SwitchProps {
    children?: ReactNode
    value: boolean | string | number | object | null | undefined
    onChange: (newValue: boolean) => void
    className?: string
    autoFocus?: boolean
    reverse?: boolean
}

export const Switch: FC<SwitchProps> = ({value, onChange, className, children, reverse}) => {

    return (
        <label className={`df aic ${className ?? ''} ${reverse ? 'fd-rr' : ''}`}>
            {children}
            <div className="switch p-r d-ib mr-4">
                <input 
                    role="switch"
                    className="h-0 w-0 o-0"
                    type="checkbox" 
                    id="toggle" 
                    checked={!!value} 
                    onChange={(e) => onChange(e.currentTarget.checked)}
                    // autoFocus={autoFocus}
                />
                <span className="slider p-a c-p"></span>
            </div>
            
        </label>
    )
}